import type { ComponentProps, Slide } from 'yet-another-react-lightbox';
import {
  createModule,
  type PluginProps,
  useController,
  useLightboxState,
} from 'yet-another-react-lightbox';

import './types.d';

function AutoCloseModule({ children, autoClose, open, on }: ComponentProps) {
  const { enabled = false } = autoClose ?? {};

  const { currentIndex, slides } = useLightboxState();
  const { close } = useController();

  const handleAutoClose = useCallback(
    (type?: 'image' | 'video') => {
      if (!type) return;
      on.autoClose?.(type);
    },
    [on]
  );

  const viewedSlidRef = useRef<Slide | null>(null);

  // whenSlideRemove
  useEffect(() => {
    if (!enabled) {
      return;
    }
    const oldSlide = viewedSlidRef.current;
    const newSlide = slides[currentIndex] ?? null;
    if (oldSlide != null && !slides.some((s) => s.key === oldSlide.key)) {
      close();
      handleAutoClose(oldSlide.type);
    }
    viewedSlidRef.current = newSlide;
  }, [slides, currentIndex, enabled, close, handleAutoClose]);
  useEffect(() => {
    if (open) return;
    viewedSlidRef.current = null;
  }, [open]);

  return children;
}

export function AutoClose({ addModule }: PluginProps) {
  addModule(createModule('AUTO_CLOSE', AutoCloseModule));
}
